import React from "react";
import Helmet from "react-helmet";
import Link from "gatsby-link";
import Img from "react-image"
import Board from "../components/board.js";
import styles from "../styles/archive.module.scss"

export default class Archives extends React.Component {
  getArchives() {
    return this.props.edges.map(edge => {
      return {
        category: edge.node.frontmatter.category,
        number: edge.node.frontmatter.number,
        title: edge.node.frontmatter.title,
        date: edge.node.frontmatter.date,
        images:edge.node.frontmatter.images,
        detailHtml:edge.node.html
      };
    });
  }

  render() {
    const events = this.getArchives();
    const thisCagegory = this.props.category;
    const categories = this.props.categories;
    return (
      <div>
        <h2 className={styles.sectionTitle}>過去の開催イベント</h2>
        <section>
        <div style={{ display: `inline-block`, float: `left`}}>
          <ul>
          {
            categories.map(category =>
                <li key={category} style={{ display: `inline-block`, marginRight: `1rem`, height: `1rem`}}>
                  <Link to={`/archives/${category}`} className={styles.category} activeClassName={styles.activeCategory}>
                    {category}
                  </Link>
                </li>
            )
          }
          </ul>
        </div>
        <div style={{clear:"both"}}></div>
        </section>
        <section>
  			{
  				( () => {
  					if (thisCagegory != "") {
  						return <h2>#{thisCagegory}</h2>;
  					}
  				} )()
  			}
  			{
  				events.map(event =>
  					<Archive key={event.number} eventInfo={event} />
  				)
  			}
        </section>
      </div>
    );
  }
}

class Archive extends React.Component {

  render() {
    const event = this.props.eventInfo;
    const img_array = event.images.split(',');
    
    return (
      <article>
          <Board>
            <div style={{marginBottom: "-10px"}}>
              <div style={{float:"right", marginRight:"1rem"}}>
              <Link to={`/archives/${event.category}/`}>
                <p　className={styles.tags}>{`#${event.category}`}</p>
              </Link>
              </div>
            </div>
            <br style={{clear:"both"}}/>
            
          <div className={styles.eventInfo}>
              <h3 className={styles.topic}>Vol.{event.number}　{event.title}</h3>
              <div dangerouslySetInnerHTML={{ __html: event.detailHtml }} />
          </div>
          <div>
            {
              ( () => {
                const cmpArray = [];
                img_array.forEach(function(img) {
                  if (img) {
                    const cmp = require(`../../images/vol${event.number}/${img.trim()}`);
                    cmpArray.push(<Img key={img} src={cmp} width="70%"/>);
                  }
                });
                return cmpArray;
              } )()
            }
          </div>
          </Board>
        </article>
    )
  }
}



// WEBPACK FOOTER //
// ./src/templates/archives.js